import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Grid,
  Box
} from '@material-ui/core';
import { 
  MuiPickersUtilsProvider, 
  KeyboardDatePicker 
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { STATS_PRESETS, getStatsDateRange } from '../../utils/dateFilters';

const StatisticsFilter = ({ filter, onChange }) => {
  const { preset, startDate, endDate } = filter;

  const handlePresetChange = (event) => {
    const newPreset = event.target.value;
    if (newPreset === STATS_PRESETS.CUSTOM) {
      onChange({ ...filter, preset: newPreset });
    } else {
      const { startDate, endDate } = getStatsDateRange(newPreset);
      onChange({
        preset: newPreset,
        startDate,
        endDate,
      });
    }
  };

  const handleDateChange = (field) => (date) => {
    onChange({
      ...filter,
      [field]: date,
      preset: STATS_PRESETS.CUSTOM,
    });
  };

  return (
    <Box mb={4}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="stats-preset-label">Preset</InputLabel>
              <Select
                labelId="stats-preset-label"
                value={preset}
                onChange={handlePresetChange}
              >
                <MenuItem value={STATS_PRESETS.LAST_30_DAYS}>Last 30 Days</MenuItem>
                <MenuItem value={STATS_PRESETS.LAST_90_DAYS}>Last 90 Days</MenuItem>
                <MenuItem value={STATS_PRESETS.YTD}>Year to Date</MenuItem>
                <MenuItem value={STATS_PRESETS.FISCAL_YEAR}>Fiscal Year</MenuItem>
                <MenuItem value={STATS_PRESETS.CUSTOM}>Custom Range</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <KeyboardDatePicker
              fullWidth
              label="Start Date"
              format="MM/dd/yyyy"
              value={startDate}
              onChange={handleDateChange('startDate')}
              KeyboardButtonProps={{
                'aria-label': 'change start date',
              }}
              data-testid="date-picker-start-date"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <KeyboardDatePicker
              fullWidth
              label="End Date"
              format="MM/dd/yyyy"
              value={endDate}
              onChange={handleDateChange('endDate')}
              KeyboardButtonProps={{
                'aria-label': 'change end date',
              }}
              data-testid="date-picker-end-date"
            />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Box>
  );
};

export default StatisticsFilter;
